import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=7621fb7c&scoped=true"
import script from "./Address.vue?vue&type=script&lang=ts"
export * from "./Address.vue?vue&type=script&lang=ts"
import style0 from "./Address.vue?vue&type=style&index=0&id=7621fb7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7621fb7c",
  null
  
)

export default component.exports